<template lang="pug">
.export-selector.dropdown(
  :class='{ open : isExportSelectorOpened }'
  v-on-clickaway='closeExportSelector'
)
  a.dropdown-toggle(
    v-tooltip.bottom="'Export Data'"
    href='#'
    data-toggle='dropdown'
    @click.prevent='openExportSelector'
  )
    i.fas.fa-table
  .dropdown-menu.dropdown-menu-right
    .export.selector.grid-filter
      //-span.close-icon(@click="closeExportSelector")
        i.fal.fa-times
      p.column-title
        | Export
        ed-select.inline.small.tiny.label-right(
          v-tooltip.bottom="'Choose between exporting only visible columns or all columns'"
          field-label='Columns'
          hide-optional
          :options='exportOptions'
          v-model='exportOption'
          label='label'
          open-direction='over'
        )
      .container-
        .row
          .col-md-12
            p Download as:
            ul.types
              li(v-for='type in types')
                a.type(href='#' @click.prevent='doExport(type)')
                  i.icon(:class='Types[type].icon')
                  | {{ Types[type].label }}
  iframe.export-frame(frameborder=0 :src='exportUri')
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

const exportOptions = [
  { label: 'Selected', value: false },
  { label: 'All', value: true }
]

const Types = {
  'csv': { label: 'CSV', icon: 'fas fa-file fa-file-csv' },
  'xls': { label: 'XLS/XLSX', icon: 'fas fa-file-excel' },
  'pdf': { label: 'PDF', icon: 'fas fa-file-pdf' },
  'doc': { label: 'Word Document', icon: 'fas fa-file-word' }
}

import { Eved, EventBus }     from '@/event-bus'
import { Filter }             from './adapters'
import { mixin as clickaway } from 'vue-clickaway'
import { i18n }               from '@/lang/lang'

export default {
  name: 'export-selector',

  mixins: [ clickaway ],

  props: {
    types: {
      type: Array,
      default: function () {
        return ['xls']
      }
    },
    endpoint: String
  },

  data() {
    return {
      //
      Types,
      isExportSelectorOpened: false,
      exportOptions,
      exportOption: exportOptions[0],
      exportUri: 'about:blank'
    }
  },

  methods: {
    //
    t: (key) => i18n.t(key),

    openExportSelector() {
      this.isExportSelectorOpened = !this.isExportSelectorOpened
    },

    closeExportSelector() {
      if (this.isExportSelectorOpened) {
        this.isExportSelectorOpened = false
      }
    },

    getExportUri(type) {
      //
      const gridApi  = this.$parent.gridOptions.api
      const endpoint = this.$parent.endpoint.split('/')[1]
      const baseUri  = this.endpoint
        ? `${this.api.env}/${this.endpoint}`
        : `${this.api.env}/${endpoint}/ExportList`

      const allColumns  = gridApi.columnController.columnApi.getAllColumns() || []
      const sortModel   = gridApi.getSortModel()
      const filterModel = gridApi.getFilterModel()
      const limit       = gridApi.rowModel.infiniteCache.virtualRowCount || 0
      const searchTerm  = this.$parent.searchTerm

      let columns       = []
      let sortColumn    = sortModel.length ? sortModel[0].colId : null
      let sortDirection = sortModel.length ? sortModel[0].sort.toUpperCase() : null
      let filter        = Filter.mixin(filterModel, searchTerm, this.$parent.screen) || {}

      const filteredColumns = allColumns.filter(column => column.colDef.headerName !== '_')

      filteredColumns.forEach(column => {
        column.colDef.action ||
        (this.exportOption.value ? false : !column.visible) ||
        columns.push({
          Field: column.colDef.field,
          Name: column.colDef.headerName
        })
      })

      columns = global.encodeURI(JSON.stringify(columns))
      filter  = global.encodeURI(JSON.stringify(filter))

      return `${baseUri}?` +
                `limit=${limit}&` +
                `start=0&` +
                `searchTerm=${searchTerm}&` +
                `Dir=${sortDirection}&` +
                `sort=${sortColumn}&` +
                `filter=${filter}&` +
                `columns=${columns}&` +
                `allColumns=${this.exportOption.value}&` +
                `getJustVisibleColumns=${!this.exportOption.value}&` +
                `columnsToLoad=${columns}`
    },

    doExport(type) {
      const slug = `${this.$parent.name || this.$parent.label} > ${type}`

      this.exportUri = 'about:blank'
      this.$nextTick(() => {
        this.exportUri = this.getExportUri(type)
      })
      this.closeExportSelector()

      EventBus.$emit(Eved.GENERIC.EXPORT, slug)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

// EXPORT FRAME
.export-frame {
  width: 0;
  height: 0;
  position: absolute;
  visibility: hidden;
  overflow: hidden;
}

// EXPORT SELECTOR
.export-selector {
  cursor: pointer;
  display: inline-block;
  margin: 0 0 0 .4em;
  line-height: 1.5em;
  vertical-align: middle;

  &.export-btn .dropdown-toggle {
    padding: 0;
    .open > &, &:hover {
      background: none;
    }
  }

  &.export-btn {
    margin: 0;
  }

  &:not(.export-btn) .dropdown-toggle .btn,
  &.export-btn .dropdown-toggle .icon {
    display: none;
  }

  .form-group {
    margin: 0;

    >>> .dawnSelect__input {
      cursor: pointer;
      text-transform: uppercase;
    }
  }

  .types {
    list-style: none;
    padding: 0;

    .type {
      display: block;
      padding: 0;
      &:hover, &:active, &:focus {
        @include theme {
        color: v(ink);
        background: lighten(v(secondary-04), 5%);
        }
      }
      box-shadow: none;
      margin: 0;
    }

    .icon {
      min-width: 1.2em;
      font-size: $font-size-base;
    }
  }

  .export.selector {
    padding: 0 8px 0;
    line-height: 1.8em;
  }
  .dropdown-menu {
    //
    margin-top: 0;
    font-size: $font-size-base-sm;
    min-width: 200px;
    z-index: 9999;

    &-right {
      margin-right: -.2em;
    }
  }

  .close-icon {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    z-index: 9;

    line-height: normal;
    font-weight: 100;
    @include theme {
    color: v(ink);
    }
    margin-left: 2rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

.fa-file {
  &-csv { color: gray }
  &-excel { color: green }
  &-pdf { color: red }
  &-word { color: blue }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/export-data.vue